import Script from "next/script";
import { useEffect, useState } from "react";
import styles from "./KlarnaPaymentMessage.module.scss";
import { RuntimeConfig } from "@/types/types.ts";

type Props = {
  currentPrice?: string;
  isSelected: boolean;
  runtimeConfig: RuntimeConfig;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "klarna-placement": {
        id: string;
        "data-key": string;
        "data-locale": string;
        "data-purchase-amount"?: string;
      };
    }
  }
}

export const KlarnaPaymentMessageUI = ({
  currentPrice,
  isSelected,
  runtimeConfig,
}: Props) => {
  const [amount, setAmount] = useState<string | undefined>("");

  useEffect(() => {
    if (isSelected) {
      const flatPrice = Math.round(Number(currentPrice) * 100);
      setAmount(flatPrice.toString());
    }
  }, [isSelected, currentPrice]);

  const KlarnaPlacementElement = () => (
    <klarna-placement
      id="klarnaPlacementMessage"
      data-key="credit-promotion-auto-size"
      data-locale="en-GB"
      data-purchase-amount={amount}
    ></klarna-placement>
  );

  return (
    <>
      <Script
        async
        data-environment={runtimeConfig?.klarnaEnvironment}
        src={runtimeConfig?.klarnaScriptURL}
        data-client-id={runtimeConfig?.klarnaClientId}
      />
      <style>
        {`
          #klarnaPlacementMessage::part(osm-container),
          #klarnaPlacementMessage::part(osm-cta){
            color: #141414;
            font-family: GillSansforJL, Gill Sans, Gill Sans MT, GillSansMTStd-Medium, Avenir, Corbel, Arial, Helvetica, sans-serif;
          }
         
          #klarnaPlacementMessage::part(osm-legal) {
            color: #6F6F6F;
            text-align: left;
          }
        `}
      </style>
      <div
        className={styles.klarnaPaymentMessage__block}
        data-component="KlarnaPaymentMessage"
        data-testid="klarna-payment-message-container"
      >
        <KlarnaPlacementElement />
      </div>
    </>
  );
};
